// ============================================================================
// FSA TEMPLATE UPGRADE SERVICE (ADR-0004 Phase 2)
// ============================================================================
// Backend controller: FsaTemplateUpgradesController → /api/v1/FsaTemplateUpgrades

import { get, post } from '../../client/axiosClient';
import { buildEndpoint } from '../../endpoints/base.endpoints';
import type { ApiResponse, ID } from '../../types';
import type { TemplateUpgradePreview, TemplateUpgradeResult } from '../../types/fsa/templateUpgrade.types';

class FsaTemplateUpgradeService {
  /** Code-mapped diff of moving the engagement to targetVersion (latest when omitted). */
  async preview(engagementId: ID, targetVersion?: number | null): Promise<TemplateUpgradePreview> {
    const qs = targetVersion != null ? `?targetVersion=${targetVersion}` : '';
    const response = await get<ApiResponse<TemplateUpgradePreview>>(
      buildEndpoint(`/FsaTemplateUpgrades/by-engagement/${engagementId}/preview${qs}`),
    );
    return response.data.data as TemplateUpgradePreview;
  }

  /** Applies the upgrade transactionally (re-keys every engagement reference by code). */
  async upgrade(engagementId: ID, targetVersion?: number | null): Promise<TemplateUpgradeResult> {
    const response = await post<ApiResponse<TemplateUpgradeResult>>(
      buildEndpoint(`/FsaTemplateUpgrades/by-engagement/${engagementId}`),
      { targetVersion: targetVersion ?? null },
    );
    return response.data.data as TemplateUpgradeResult;
  }
}

export const fsaTemplateUpgradeService = new FsaTemplateUpgradeService();
export default fsaTemplateUpgradeService;
